import { useMemo } from "react";
import { XeroClient } from "../services";
import { useOrganisationContext } from "./useOrganisationContext";

export const useXeroClient = (args = {}) => {
  const { selectedOrganisation } = useOrganisationContext();
  return useMemo(() => XeroClient(args), [selectedOrganisation?.id]);
};
